<template>
  <div class="fintech g-container">
    <div class="tip1">{{ $t('home.fintechTip1') }}</div>
    <h2 class="g-title title">{{ $t('home.fintechTitle') }}</h2>
    <div class="tip2">{{ $t('home.fintechTip2') }}</div>
    <div class="tip3">{{ $t('home.fintechTip3') }}</div>
    <div class="card__wrapper">
      <div class="card">
        <img class="card__img" src="../../assets/fintech1.png" alt="">
        <div class="card__title g-font-mid">{{ $t('home.fintechCard1') }}</div>
        <div class="card__content">{{ $t('home.fintechCard1Content') }}</div>
      </div>
      <div class="card second">
        <img class="card__img" src="../../assets/fintech2.png" alt="">
        <div class="card__title g-font-mid">{{ $t('home.fintechCard2') }}</div>
        <div class="card__content">{{ $t('home.fintechCard2Content') }}</div>
      </div>
      <div class="card third">
        <img class="card__img" src="../../assets/fintech3.png" alt="">
        <div class="card__title g-font-mid">{{ $t('home.fintechCard3') }}</div>
        <div class="card__content">{{ $t('home.fintechCard3Content') }}</div>
        <div class="card__coming">{{ $t('home.fintechComing') }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Fintech',
};
</script>

<style lang="scss" scoped>
  .fintech {
    padding-top: 120px;
    text-align: center;
  }

  .tip1 {
    font-size: 16px;
    line-height: 28px;
    color: var(--color-tip);
  }

  .title {
    margin-top: 10px;
  }

  .tip2 {
    margin: 20px auto 0;
    font-size: 24px;
    line-height: 26px;
    color: var(--color-content);
  }

  .tip3 {
    max-width: 900px;
    margin: 60px auto 0;
    font-size: 18px;
    line-height: 26px;
    color: var(--color-content);
  }

  .card__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 30px;
    margin-top: 90px;
    justify-items: center;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
      grid-row-gap: 40px;
    }
  }

  .card {
    overflow: hidden;
    vertical-align: top;
    padding: 0 40px;
    min-height: 500px;
    box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.08);
    border-radius: 10px;

    @media (max-width: 960px) {
      max-width: 400px;
    }

    .card__title {
      opacity: 1;
    }

    .card__content {
      opacity: .6;
    }

    &.second {
      .card__title {
        opacity: .8;
      }
      .card__content {
        opacity: .48;
      }
    }

    &.third {
      .card__title {
        opacity: .7;
      }
      .card__content {
        opacity: .42;
      }
    }
  }

  .card__img {
    margin: 80px auto 0;
    width: 60px;
    height: 60px;
  }

  .card__title {
    margin-top: 30px;
    font-size: 24px;
    line-height: 28px;
  }

  .card__content {
    margin-top: 20px;
    font-size: 18px;
    line-height: 28px;
  }

  .card__coming {
    margin-top: 10px;
    font-size: 16px;
    line-height: 28px;
    color: rgba(255, 171, 70, .7);
  }

  @media (max-width: 1320px) {
    .card {
      margin: 0 auto 40px;
    }
  }

  @media (max-width: 960px) {
    .tip2, .tip3 {
      max-width: 600px;
    }
  }
</style>
